import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'

import AddCompetition from '../../dataDisplay/AddCompetition'
import './../../ui.style.scss'

class AddCompetitionModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      disable: true
    }
  }

  resetState = () => {
    const state = {
      newTitle: undefined,
      newMailId: undefined,
      disable: true
    }
    this.setState({ ...state })
  }

  render () {
    const { visible, handleCancel, title, okText, project } = this.props
    return (

      <Modal
        className='general-modal add-competition-modal'
        visible={visible}
        closable={false}
        title={title}
        // okButtonProps={{ disabled: !(newTitle), loading: loading }}
        // onOk={this.handleSubmit}
        onCancel={handleCancel}
        okText={okText}
        cancelText='Back'
        // afterClose={this.resetState}
        width='934px'
        centered
        destroyOnClose
        maskClosable={false}
      >
        <AddCompetition project={project} />
      </Modal>
    )
  }
}

AddCompetitionModal.propTypes = {
  /** visible action of AddCompetitionModal. */
  visible: PropTypes.bool,
  /** handleCancel action of AddCompetitionModal. */
  handleCancel: PropTypes.func
}

AddCompetitionModal.defaultProps = {
}

export default AddCompetitionModal
